import { Component, Input, OnInit } from '@angular/core';

export type NcSizeType = 'mini' | 'small' | 'default' | 'large';

@Component({
  selector: 'nc-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.less']
})
export class LoadingComponent implements OnInit {
  //1：圆球排列
  //2：彩色跳动
  //3：旋转呼吸
  //4：多彩球体
  //5：爱心跳动
  //6：旋转齿轮
  //7：弹跳小球
  //8：滑块滑动
  //9：容器填充
  //10：方块跳动
  //11-40：spin
  //41-50：hypnotic

  /** 加载类型 */
  @Input() ncType: number = 1;
  /** 加载大小 */
  @Input() ncSize: NcSizeType = 'default';
  /** 加载提示 */
  @Input() ncTips: string = '';
  /** 加载提示颜色 */
  @Input() ncTipsColor: string = '#1890ff';
  /** 加载提示字体粗细 */
  @Input() ncTipsWeight: string = '400';

  constructor() { }

  ngOnInit(): void {
  }

}
